<template>
  <div>
    <hr class="my-6" />
    <p class="mb-1">
      <strong>ชื่อยา: </strong>{{ this.medicine.genericName }} /
      {{ this.medicine.tradeName }}
    </p>
    <p class="mb-1"><strong>จำนวน: </strong>{{ amountLabel }}</p>
    <p class="mb-1">
      <strong>วิธีรับประทาน: </strong>
      <v-textarea
        name="dosage-instruction"
        label="วิธีรับประทาน"
        single-line
        v-model="dosageLabel"
        outlined
        rows="1"
        auto-grow
        density="compact"
        hide-details
      />
    </p>
    <p class="mb-1">
      <strong>คำแนะนำ: </strong
      ><v-textarea
        name="advice-instruction"
        label="คำแนะนำ"
        single-line
        v-model="adviceLabel"
        outlined
        rows="1"
        auto-grow
        density="compact"
        hide-details
      />
    </p>
  </div>
</template>

<script>
export default {
  name: 'MedicineDetail',
  props: {
    medicine: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      amountLabel: this.initAmountLabel(),
      dosageLabel: this.initDosageLabel(),
      adviceLabel: this.initAdviceLabel(),
    };
  },
  methods: {
    initAmountLabel: function () {
      const unitMap = {
        pill: 'เม็ด',
        pills: 'เม็ด',
        tablet: 'เม็ด',
        tablets: 'เม็ด',
        tab: 'เม็ด',
        tabs: 'เม็ด',
        pack: 'แผง',
        packs: 'แผง',
      };

      let matches = /(\d+) ([a-zA-Z]+)\/([a-zA-Z]+)/.exec(this.medicine.sellUnit);
      const count = matches ? matches[1] : null;
      const subUnitName = matches ? matches[2] : null;
      const bigUnitName = matches ? matches[3] : null;

      const isValidXPerY = count && subUnitName && bigUnitName;

      const unit = this.medicine.unit.toLowerCase();
      const translatedUnit = unitMap[unit] || this.medicine.unit;
      const translatedSubUnit = isValidXPerY ? unitMap[subUnitName.toLowerCase()] || subUnitName : null;
      const translatedBigUnit = isValidXPerY ? unitMap[bigUnitName.toLowerCase()] || bigUnitName : null;
      if (['pill', 'pills'].includes(unit)) {
        return `${this.medicine.quantity} ${translatedUnit}`;
      } else {
        return (
          `${this.medicine.quantity} ${translatedUnit}` +
          (isValidXPerY ? ` (${count} ${translatedSubUnit}/${translatedBigUnit})` : '')
        );
      }
    },
    initDosageLabel: function () {
      return `${
        this.medicine.dosage && this.medicine.dosage.trim() !== this.medicine.howToTake.trim()
          ? this.medicine.dosage
          : ''
      } ${this.medicine.howToTake} ${
        this.medicine.time && this.medicine.time.trim() !== this.medicine.howToTake.trim() ? this.medicine.time : ''
      }`;
    },
    initAdviceLabel: function () {
      return this.medicine.moreDetail || '';
    },
  },
};
</script>
